// extracted by mini-css-extract-plugin
export default {"container":"FloatingContact_container_lLMSS","avatar":"FloatingContact_avatar_E3qjK","title":"FloatingContact_title_dTkbd","text":"FloatingContact_text_ZHBbI"};